import { Component } from '@angular/core';

@Component({
  selector: 'app-advisor-nav',
  templateUrl: './advisor-nav.component.html',
  styleUrls: ['./advisor-nav.component.css']
})
export class AdvisorNavComponent {

}
